import React from 'react';
import { TableContainer } from '@carbon/react';

export interface CrudShellProps {
  /** Absent when the page's own heading already names it (see CrudPresentation.hideTitle). */
  title?: string;
  description: string;
  children: React.ReactNode;
}

export const CrudShell = React.memo((props: CrudShellProps) => (
  <TableContainer title={props.title} description={props.description}>
    {props.children}
  </TableContainer>
));
CrudShell.displayName = 'CrudShell';
